import React, { useMemo } from 'react';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import { ClientBrandIcon } from '@/components/icons/ClientBrandIcon';
import { RelationshipsIcon } from '@/components/icons/RelationshipsIcon';
import { getClientLogoDomain } from '@/utils/clientLogo';

const PREVIEW_ICON_SIZE = '1.5em';

const RelationshipContactHeader = () => {
	const { values } = useFormikContext();
	const theme = useTheme();

	const title =
		[values?.firstName, values?.lastName].filter(Boolean).join(' ').trim() || 'Contact';
	const subtitle = values?.email || values?.roleTitle || '';

	const logoDomain = useMemo(
		() =>
			getClientLogoDomain({
				mainContact: {
					Email: values?.email,
					email: values?.email,
				},
			}),
		[values?.email],
	);

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: 2,
				mb: 3,
				p: 2,
				borderRadius: 2,
				boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
				backgroundColor: theme.palette.action.hover,
			}}
		>
			<Avatar sx={{ width: 48, height: 48, bgcolor: 'transparent' }}>
				<ClientBrandIcon
					domain={logoDomain}
					height={PREVIEW_ICON_SIZE}
					width={PREVIEW_ICON_SIZE}
					fallbackIcon={
						<RelationshipsIcon
							width={PREVIEW_ICON_SIZE}
							height={PREVIEW_ICON_SIZE}
							{...(theme.palette.mode === 'dark' && { bgColor: 'transparent' })}
						/>
					}
				/>
			</Avatar>
			<Box sx={{ minWidth: 0 }}>
				<Typography variant='h6' fontWeight='bold' noWrap>
					{title}
				</Typography>
				{subtitle && (
					<Typography variant='body2' color='textSecondary' noWrap>
						{subtitle}
					</Typography>
				) }
			</Box>
		</Box>
	);
};

export default RelationshipContactHeader;
